import homepageTypes from './types/homepage'
import homepageService from '@/api/homepage'

const state = {}

const actions = {
  /**
   * 获取河道水位
   */
  [homepageTypes.GET_LATEST_WATER_LEVEL] ({ commit }, {
    sID = '22',
    sTID = '',
    stationType = '',
    waterFactor = ''
  }) {
    return new Promise((resolve, reject) => {
      homepageService.getLatestWaterLevel({
        sID,
        sTID,
        stationType,
        waterFactor
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取水库水位
   */
  [homepageTypes.GET_HOURLY_RIVER_LEVEL] ({ commit }, {
    sID = '',
    sTID = '',
    beginDate = '',
    endDate = '',
    stationType = ''
  }) {
    return new Promise((resolve, reject) => {
      homepageService.getHourlyRiverLevel({
        sID,
        sTID,
        beginDate,
        endDate,
        stationType
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取水库蓄水情况
   */
  [homepageTypes.GET_RESERVOIR_IMPOUNDMENT_INFO] ({ commit }, {
    stid = ''
  }) {
    return new Promise((resolve, reject) => {
      homepageService.getReservoirImpoundmentInfo({
        stid
      }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
  * 水库超汛限
  */
  [homepageTypes.GET_OVERFLOW_WARNING_WATER] ({ commit }, { stationType = '', sID = '', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      homepageService.getOverflowWarningWater({ stationType, sID, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 雨量超警
   */
  [homepageTypes.GET_OVERFLOW_WARNING_RAIN] ({ commit }, { sID = '21', mainStation = '' }) {
    return new Promise((resolve, reject) => {
      homepageService.getOverflowWarningRain({ sID, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
